import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
    const { user, checking } = useAuth();
    const loc = useLocation();

    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-black text-zinc-400">
                <span className="font-mono text-xs tracking-widest uppercase">
                    Checking session…
                </span>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
    }
    return children;
}
